import React, { useState } from "react";

import Typography from "../../../../foundation/Typography/V2";
import { useWindowDimensions } from "../../../../hooks";
import theme from "../../../../foundation/Theme";

import {
  StyledLeftSection,
  TitleContainer,
  Title,
  ArrowRight,
  List,
  ListItem,
  ListItemContent,
  StyledSubmitButton,
  TimeLineStep,
} from "./style";

function LeftSection({ data = {} }) {
  const { width } = useWindowDimensions();

  const [continueReading, setContinueReading] = useState(false);

  return (
    <StyledLeftSection>
      <TitleContainer>
        <ArrowRight icon="icon-arrow-right-filled" />
        <Title variant="heading4">{data?.title}</Title>
      </TitleContainer>
      <List maxHeight={width <= 600 && !continueReading && "460px"}>
        {data?.list?.map((howItWork, index) => (
          <ListItem key={howItWork?.title}>
            <TimeLineStep
              backgroundColor={
                index === 0 ? theme.colorsV2.shyft.green : theme.colors.white
              }
            >
              <Typography
                variant="paragraph3"
                fontFamily="var(--man-700)"
                color={
                  index === 0 ? theme.colors.white : theme.colorsV2.shyft.green
                }
              >
                {index + 1}
              </Typography>
            </TimeLineStep>
            <ListItemContent>
              <Typography
                variant="paragraph1"
                fontSize={["18px", "20px", "22px"]}
                lineHeight={["24px", "26px", "28px"]}
                fontFamily="var(--man-700)"
                color={theme.colorsV2.shyft.purple_text}
                mb="4px"
              >
                {howItWork?.title}
              </Typography>
              <Typography
                variant="paragraph4"
                fontSize={["12px", "14px", "16px"]}
                lineHeight={["18px", "20px", "22px"]}
                color={theme.colorsV2.blueGray.shade_700}
              >
                {howItWork?.subTitle}
              </Typography>
            </ListItemContent>
          </ListItem>
        ))}
        {width <= 600 && !continueReading && (
          <StyledSubmitButton onClick={() => setContinueReading(true)}>
            Continue Reading
          </StyledSubmitButton>
        )}
      </List>
    </StyledLeftSection>
  );
}

LeftSection.propTypes = {};

LeftSection.defaultProps = {};

export default LeftSection;
